export const DEFAULT_LAYOUT_SLOT_NAMES = [
    'labelPrefix',
    'labelPostfix',
    'inputContainerPrefix',
    'inputContainerPostfix',
    'inputInnerPrefix',
    'inputInnerPostfix',
    'errorPrefix',
    'errorPostfix',
];

// Slot names for list items (excludes inputContainerPostfix which is used at the list level)
export const LIST_ITEM_SLOT_NAMES = DEFAULT_LAYOUT_SLOT_NAMES.filter(
    (name) => name !== 'inputContainerPostfix',
);
